module.exports = __webpack_public_path__ + "static/media/shop-img18.904e04c8.png";